import React, { ReactNode } from "react";

import Switch from "antd/es/switch";
import Tooltip from "antd/es/tooltip";

import styles from "./Section.module.scss";

interface Props {
  active?: boolean;
  children?: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  onToggleActivation?: (active: boolean) => void;
  title: ReactNode;
  tooltip?: ReactNode;
}

const Section: React.FC<Props> = ({
  active,
  children,
  description,
  disabled,
  onToggleActivation,
  title,
  tooltip,
}) => (
  <div className={styles.container}>
    <div className={styles.header}>
      <h3 className={styles.title}>{title}</h3>
      <div>
        <Tooltip title={tooltip}>
          <Switch
            checked={active}
            className={styles.switch}
            disabled={disabled}
            onChange={onToggleActivation}
            size="small"
          />
        </Tooltip>
      </div>
    </div>
    {description && <div className={styles.description}>{description}</div>}
    <div>{children}</div>
  </div>
);

export default Section;
